import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=44f39e31&scoped=true&"
import script from "./RolesForm.vue?vue&type=script&lang=js&"
export * from "./RolesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f39e31",
  null
  
)

export default component.exports